(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("OncadeSDK", ["axios"], factory);
	else if(typeof exports === 'object')
		exports["OncadeSDK"] = factory(require("axios"));
	else
		root["OncadeSDK"] = factory(root["axios"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__674__) => {
return 